import { fetchWithDefaults } from '../config/fetchDefault';
import { removeFilter } from '../features/filterSlice';


const deleteFilter = async (filter, dispatch) => {
    try {
        const requestOptions = {
            method: 'DELETE'
        };
        const response = await fetchWithDefaults(`/filters?filter=${filter}`, requestOptions);

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const jsonData = await response.json();
        if(jsonData){
            dispatch(removeFilter(filter));
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

const saveFilter = async (agent, teamId, filterName, filterOptions, range, sortyBy, filterParams) => {
    try {
        const response = await fetchWithDefaults(`/filters/saveCustomFilter`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                agent,
                teamId,
                filterName,
                filterOptions,
                range,
                sortyBy,
                filterParams
            })
        })

        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        const jsonData = await response.json();
        return jsonData
    } catch (error) {

    }
}
export { deleteFilter, saveFilter};